import $ from 'jquery';
import 'jquery-validation';

$(function() {
    const $form = $('#reviewsNewMultiStepsForm');
    let currentStep = 1;

    // Names of the four breakdown_ratings fields
    const breakdownRatingsNames = ['quality', 'communication', 'punctuality', 'pricing'];

    // Take the error message of breakdownRatings
    const breakdownRatingsError = $(`input[name="quality"]`).data('msg-required');

    // Custom validator: ensure each breakdownRatings is checked
    $.validator.addMethod(
        'breakdownRatingsAllChecked',
        function(_, element) {
            // return true only if every rating field has one checked radio
            return breakdownRatingsNames.every(name =>
                $(`input[name="${name}"]:checked`, element.form).length
            );
        },
        breakdownRatingsError
    );

    // Initialize the validator
    const validator = $form.validate({
        // don’t validate hidden steps
        ignore: ':hidden',
        // turn off auto‑validation on click/focus/keyup
        onclick: false,
        onkeyup(element) {
            // only validate comment as they type once they hit minLength
            if (element.id === 'comment' && element.value.length >= element.minLength) {
                this.element(element);
            }
        },
        onfocusout(element) {
            // validate comment on blur so they see errors if < minLength
            if (element.id === 'comment') {
                this.element(element);
            }
        },
        errorClass: 'invalid-feedback',
        errorElement: 'div',
        rules: {
            // Apply breakdownRatings to quality only; breakdownRatingsAllChecked ensures quality, communication, punctuality, and pricing are checked
            quality: { breakdownRatingsAllChecked: true }
        },
        messages: {
            quality: { breakdownRatingsAllChecked: breakdownRatingsError }
        },
        errorPlacement(error, element) {
            if (element.attr('name') === 'quality') {
                error.appendTo('.breakdown_ratings-error');
            }
            else if (element.attr('name') === 'comment') {
                error.appendTo('.public_reviews-error');
            }
            else {
                error.insertAfter(element);
            }
        },
        highlight(el) {
            // Add invalid class, remove valid
            $(el).addClass('is-invalid').removeClass('is-valid');
            updateButtonState();
        },
        unhighlight(el) {
            // Add valid class, remove invalid
            $(el).addClass('is-valid').removeClass('is-invalid');
            updateButtonState();
        }
    });

    // Whenever any rating changes, re‑check the custom validator
    $form.on('change', breakdownRatingsNames.map(name => `input[name="${name}"]`).join(', '), () => {
            // if all four are filled, clear that one error
            if (breakdownRatingsNames.every(name => $(`input[name="${name}"]:checked`).length)) {
                validator.element('input[name="quality"]');
            }
            updateButtonState();
        }
    );

    // Step navigation
    function updateButtonState() {
        // find the button(s) on the current step
        const $step = $(`.step[data-step-index="${currentStep}"]`);
        if ($step.data('skippable')) return; // never disable skippable
        const $btn = $step.find('.btn-next, button[type="submit"]');

        // Disable (opacity-50) if form invalid, else enable
        validator.checkForm()
            ? $btn.removeClass('opacity-50')
            : $btn.addClass('opacity-50');
    }

    function goToStep(step) {
        // fade out current, fade in target, update index + button state
        $('.step:visible').fadeOut(400, () => {
            $(`.step[data-step-index="${step}"]`).fadeIn(400, () => {
                currentStep = step;
                updateButtonState();
            });
        });
    }

    updateButtonState(); // Initial state

    // Next / skip buttons
    $(document).on('click', '.btn-next, .btn-skip', function() {
        if (!validator.form()) return;            // don’t advance if invalid
        const next = $(this).data('next-step');
        if (next != null) goToStep(next);
    });

    // Back button
    $(document).on('click', '.btn-back', function() {
        const prev = $(this).data('prev-step');
        if (prev != null) goToStep(prev);
    });

    // Final form submission
    $form.on('submit', function(e) {
        e.preventDefault();
        if (!validator.form()) return; // stop if invalid

        const contractId = $form.data('contract-id');
        const comment    = $form.find('textarea[name="comment"]').val();

        // Build the review_details array automatically
        const reviewDetails = breakdownRatingsNames.map(name => ({
            detail_name: name,
            detail_rate: +$form.find(`input[name="${name}"]:checked`).val()
        }));

        // Payload ready for Rails
        const payload = {
            review: {
                contract_id:    contractId,
                comment:        comment,
                review_details: reviewDetails
            }
        };

        // Send a POST request to /reviews
        fetch($form.attr('action')!, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')!
            },
            body: JSON.stringify(payload)
        })
        .then(response => {
            if (response.redirected) {
                window.location.href = response.url;
                return;
            }
            return response.json();
        })
        .then(json => {
            if (json) console.log('Review submitted:', json);
        })
        .catch(() => {
            $('.form_main-error').removeClass('d-none');
        });


        // Hide any server‑error banner once they retry
        $form.on('change input', ':input', () => {
            $('.form_main-error').addClass('d-none');
        });
    });
});
